<template>
    <b-container class="sideOverlay h-100" fluid>
        <b-row class="h-100" align-h="end">
            <b-col class="sideMenu" align-v="center" col xs="12" sm="12" md="12" xl="7" lg="7">
                <b-row class="h-10" align-h="end">
                    <b-col class="close" col xs="12" sm="12" md="12" xl="12" lg="12">
                        <a href="javascript:void(0);" @click="closeNavigation"><b-icon icon="x"></b-icon></a>
                    </b-col>
                </b-row>

                <b-row class="navigation ml-3">
                    <b-col cols="12" class="mb-4">
                        <a href="javascript:void(0);" @click="goto('/')">Home</a>
                    </b-col>
                    <b-col cols="12" class="mb-4">
                        <a href="javascript:void(0);" @click="goto('/servicios')">Servicios</a>
                    </b-col>
                    <b-col cols="12" class="mb-4">
                        <a href="https://medium.com/ozmo" target="_blank">Publicaciones</a>
                    </b-col>
                </b-row>

                <b-row class="networking ml-3">
                    <!-- <b-button class="ozmo-btn-outline-white btn-ctn" @click="launchCollab">Trabaja con nosotros</b-button> -->
                    <b-button class="ozmo-btn-outline-white btn-ctn" @click="launchContact">Contáctanos</b-button>
                </b-row>
                <b-row class="networking ml-3">
                    <div>
                        <a href="https://www.linkedin.com/company/ozmo-futures-design" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'linkedin-in']" /></div></a>
                        <a href="https://twitter.com/OzmoFutures" target="_blank"><div class="icon"><font-awesome-icon :icon="['fab', 'twitter']" /></div></a>
                        <a href="https://www.instagram.com/ozmofutures/" target="_blank"><div class="icon" icon="circle-fill"><font-awesome-icon :icon="['fab', 'instagram']" /></div></a>
                        <a href="https://medium.com/ozmo" target="_blank"><div class="icon" icon="circle-fill"><font-awesome-icon :icon="['fab', 'medium-m']" /></div></a>
                    </div>
                </b-row>
                <b-row class="contact ml-3">
                    <div>
                        <p><a href="mailto:futures@ozmo.mx"><b-icon  icon="envelope"></b-icon> futures@ozmo.mx</a></p>
                        <p><a href="tel:5592253233" @click="launchPhoneEvent"><b-icon  icon="phone"></b-icon> 55 9225 3233</a></p>
                        <br>
                        <p>© {{currentDate}} Ozmo Futures Design</p>
                    </div>
                </b-row>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { eventBus } from '../main'
import * as typeformEmbed from '@typeform/embed'

export default {
    data() {
        return{}
    },
    computed: {
        currentDate() {
            const today = new Date();
            return today.getFullYear();
        }
    },
    methods: {
        closeNavigation() {
            eventBus.$emit('closeNavigation')
        },
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
            setTimeout(() => {
            eventBus.$emit('closeNavigation')
            }, 500);
            
        },
        launchCollab() {
            typeformEmbed.makePopup(
                'https://ozmomx.typeform.com/to/vwqXW6',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchContact() {
            typeformEmbed.makePopup(
                // 'https://ozmomx.typeform.com/to/YPa8WK93?utm_source=website&utm_medium=section&utm_campaign=website2022&utm_content=navigation',
                'https://www.cognitoforms.com/Kinit1/ContactoWeb?entry={"Leads":{"Ref":"website-navigation"}}',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        },
        launchPhoneEvent() {
            this.$gtag('event', 'clic', {
                'event_category': 'telefono',
                'event_label': 'exitoso',
                'value': 'exitoso'
            });
        }
    }
}
</script>

<style scoped lang="stylus">

.sideOverlay
    position absolute
    z-index 20
    background-color rgba(0,0,0,0.8)

.icon
    width 32px
    height 32px
    border-radius 32px
    line-height 32px
    background-color #FFFFFF
    text-align center
    margin-left 2rem
    float right
    txt_style($worksans-m, 20px, $ozmo-coral)

.sideMenu
    background-color $ozmo-coral

.close
    text-align right
    padding-top 3rem
    padding-right 5rem

.close .b-icon
    txt_style($worksans-m, 60px, #FFFFFF)

.navigation
    margin-top 1rem

    a
        txt_style($archia-m, 48px, #FFFFFF)

.networking
    margin-top 3rem
    margin-bottom 5rem

    .ozmo-btn
        background-color #FFFFFF
        color $ozmo-coral
        border solid 2px #FFFFFF

    p
        txt_style($worksans-r, 24px, #FFFFFF)

.btn-ctn
    margin 0 2rem

.contact
    margin-top 3rem

    p
        txt_style($worksans-r, 16px, #FFFFFF)
        line-height 32px

        span
            txt_style($worksans-r, 16px, $ozmo-gray)

        a
            txt_style($worksans-r, 16px, #FFFFFF)

    .social
        margin-top 5rem

        .b-icon
            position relative
            top: 0.5rem
            txt_style($worksans-m, 35px, #FFFFFF)
            margin-bottom -3px


@media (max-width 767px)
    .navigation
        margin-top 20px

        a
            txt_style($archia-m, 24px, #FFFFFF)

    .networking
        margin-top 68px

        .ozmo-btn
            background-color #FFFFFF
            color $ozmo-coral
            border solid 2px #FFFFFF

        p
            txt_style($worksans-r, 16px, #FFFFFF)

    .btn-ctn
        width 90%
        margin 1rem 0
        padding 0 1rem

    .close
        padding-top 1rem
        padding-right 1rem

    .close .b-icon
        txt_style($worksans-m, 45px, #FFFFFF)

    .correo
        cursor pointer

</style>